import {createActorContext} from '@xstate/react';
import React from 'react';

import {EntityMapMachine} from './EntityMapMachine';

// Create the actor context for the EntityMapMachine
export const EntityMapMachineContext = createActorContext(EntityMapMachine);
export const useEntityMapActorRef = EntityMapMachineContext.useActorRef;
export const useEntityMapSelector = EntityMapMachineContext.useSelector;

// Provider component to wrap the subtree
export const EntityMapMachineProvider = ({
  entityId,
  children,
}: {
  entityId: string;
  children: React.ReactNode;
}): JSX.Element => (
  <EntityMapMachineContext.Provider options={{input: {entityId}}}>
    {children}
  </EntityMapMachineContext.Provider>
);
